import React from "react";
import {cx} from "../lib/ClassSet";
import {isUS} from "../lib/CountriesAndStates";
import {hasStateProvinceForAddress} from "../lib/AddressRules";
import {generateUUID} from "../lib/UUID";
import Telephone from "./Telephone";
import "./Address.scss";
import StatusTag from "./StatusTag";

function renderAddress(address) {
  return (
    <React.Fragment key={generateUUID()}>
      <span className="name">{address.get("name", "")}</span>, {address.get("addressAddressLine1", "")}
      <span className="addressLine2">, {address.get("addressAddressLine2", "")}</span>
      , {address.get("addressCity", "")}
      <span className="stateProvince">, {address.get("addressStateProvince")}</span>
      , {address.get("addressPostcode", "")}
      , {address.get("addressCountryName", "")}
    </React.Fragment>
  )
}

const ADDRESS_TYPES = ["business", "private"];

function formatAddressType(str) {
  if (!ADDRESS_TYPES.includes(str)) return null;

  return (
    <StatusTag color={StatusTag.COLORS.OUTLINE}
      text={(str === "business") ? "commercial" : "residential"}
    />
  );
}

function renderPureAddress(address) {
  if (isUS(address.get("addressCountryCode"))) {
    return (
      <div className="address">
        <div className="addressLine1">{address.get("addressAddressLine1", "")}</div>
        <div className="addressLine2">{address.get("addressAddressLine2", "")}</div>
        <div className="addressLine3">{address.get("addressCity", "")} {address.get("addressStateProvince", "")} {address.get("addressPostcode", "")}</div>
        <div className="addressLine4">{address.get("addressCountryName", "")}</div>
      </div>
    )
  } else {
    return (
      <div className="address">
        <div className="addressLine1">{address.get("addressAddressLine1", "")}</div>
        <div className="addressLine2">{address.get("addressAddressLine2", "")}</div>
        <div className="addressLine3">{address.get("addressPostcode", "")} {address.get("addressCity", "")}<span className="stateProvince">, {address.get("addressStateProvince", "")}</span></div>
        <div className="addressLine4">{address.get("addressCountryName", "")}</div>
      </div>
    )
  }
}

const AddressInline = (props) => {
  let address = props.address;
  let classes = cx({
    "Address": true,
    "Address-inline": props.inline,
    "u-addressLine2": address.get("addressAddressLine2", "").length > 0,
    "u-email": address.get("email", "").length > 0,
    "u-attName": address.get("attName", "").length > 0,
    "u-phoneNr": address.get("phoneNr", "").length > 0,
    "u-show-type": props.showType,
    "u-showStateProvince": hasStateProvinceForAddress(address)
  })

  if (props.inline) {
    return React.createElement("span", {className: classes}, [renderAddress(address)]);
  } else {
    let attName = null;
    if (address.get("attName", "").length > 0) {
      attName = <div className="attName"><span className="label">Attn: </span>{address.get("attName")}</div>
    }
    let email = null;
    if (address.get("email", "").length > 0) {
      email = <div className="email"><span className="label">Email: </span>{address.get("email")}</div>
    }
    let phoneNr = null;
    if (address.get("phoneNr", "").length > 0) {
      phoneNr = <div className="phoneNr"><span className="label">Phone Nr: </span><Telephone nr={address.get("phoneNr")}/></div>
    }
    return (
      <div className={classes}>
        <div className="name">{address.get("name")} <span className="type">{formatAddressType(address.get("type"))}</span></div>
        {attName}
        {renderPureAddress(address)}
        <div className="extras">
          {phoneNr}
          {email}
        </div>
      </div>
    )
  }
}

AddressInline.defaultProps = {
  inline: true,
  showType: true
}

export default AddressInline;